<template>
    <MainContentSearchable title="Compañia eventos" id="companias" v-model="filters" :meta="loading ? {} : companias.meta" @updated="debouncedGetCompanias">
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de compañia eventos</h3>
            <div class="card-tools mb-3">
                <router-link :to="{ name: 'back.compania-eventos.crear' }" class="btn btn-primary" id="crear-compania">
                    Crear compañia
                </router-link>
            </div>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="!loading" :class="['table', { 'expanded': companias.data.length <= 3 }]">
                    <b-table hover :items="companias.data" :fields="fields">
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent 
                                :lastIndex="companias.data.length > 3 && index >= companias.data.length - 3"
                                v-bind:options="[
                                    { to: { name: 'back.compania-eventos.registros-verifactu', params: { compania_id: item.id} }, label: 'Registros Verifactu'},
                                    { to: { name: 'back.compania-eventos.editar', params: { compania_id: item.id} }, label: 'Editar'},
                                    { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'}
                                ]"
                            />
                            <BorrarModalComponent
                                :name="'borrar-' + item.id"
                                :title="'Borrar compañia ' + item.name"
                                confirmButton="¿Está segur@ de borrar esta compañia?"
                                @close="() => closeModal()"
                                @confirm="() => borrar(item.id)"
                            />
                        </template>
                    </b-table>
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent.vue';

    export default {
        data() {
            return {
                loading: false,
                companias: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [
                    { key: "nif", label: "NIF", class: 'text-center' },
                    { key: "nombre", label: "Nombre", class: 'text-center' },
                    { key: "direccion", label: "Direccion", class: 'text-center' },
                    { key: "ciudad", label: "Ciudad", class: 'text-center' },
                    { key: "cp", label: "CP", class: 'text-center' },
                    { key: "cuenta", label: "Cuenta", class: 'text-center' },
                    { key: "email", label: "Email", class: 'text-center' },
                    { key: "telefono", label: "Telefono", class: 'text-center' },
                    { key: "Opciones", label: "opciones", class: 'text-center' }
                ],
            }
        },
        created() {
            this.getCompanias();
            this.debouncedGetCompanias = _.debounce(this.getCompanias, 500)
        },
        methods: {
            getCompanias() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.compania-eventos.index'), params).then(res => {
                    this.companias = res.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            borrar(compania_id) {
                this.loading = true;

                let params = {
                    teatro_id: this.teatro.id,
                    company_id: compania_id,
                    filters: {}
                };
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.compania-eventos.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getCompanias();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, BorrarModalComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>